module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h1', {
    staticClass: "pl-display-3 school-name"
  }, [_vm._v(_vm._s(_vm.school_name))]), _vm._v(" "), _c('div', {
    staticClass: "meta-data-on-school pl-display-1"
  }, [_c('p', [_vm._v("\n      Data last fetched:\n      "), _c('span', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.summary_meta_data.last_fetched))])]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.summary_meta_data.queried_email ?
    'Reporting for queried email containing: ' :
    'Reporting for teachers officially assigned to this school ID in the database') + "\n      "), _c('span', {
    staticClass: "b italics"
  }, [_vm._v(_vm._s(_vm.summary_meta_data.queried_email))])])]), _vm._v(" "), _c('div', {
    staticClass: "email-query-input flex items-center"
  }, [_c('pl-input', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getSetAllSummaryData.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.email_handle_query),
      callback: function($$v) {
        _vm.email_handle_query = $$v
      },
      expression: "email_handle_query"
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "grow ba--solid bw1 br3 ttu pv2 ph3 ripple purple b b--purple",
    on: {
      "click": _vm.getSetAllSummaryData
    }
  }, [_vm._v("\n        run numbers with email\n      ")])])], 1), _vm._v(" "), _c('table', {
    staticClass: "teacher-student-data tc",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.users.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.number_of_students_enrolled))])])]), _vm._v(" "), _c('table', {
    staticClass: "tc",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('label', {
    attrs: {
      "for": "start"
    }
  }, [_vm._v("Start date:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.active_filter.start_date),
      expression: "active_filter.start_date"
    }],
    attrs: {
      "type": "date",
      "id": "active-start",
      "name": "active-start"
    },
    domProps: {
      "value": (_vm.active_filter.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.active_filter, "start_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "start"
    }
  }, [_vm._v("End date:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.active_filter.end_date),
      expression: "active_filter.end_date"
    }],
    attrs: {
      "type": "date",
      "id": "active-end",
      "name": "active-start"
    },
    domProps: {
      "value": (_vm.active_filter.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.active_filter, "end_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    attrs: {
      "disabled": !(_vm.active_filter.start_date && _vm.active_filter.end_date)
    },
    nativeOn: {
      "click": function($event) {
        return _vm.calculateActiveTeachersAndStudents.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Calculate\n        ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.active_info.teachers))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.active_info.students))])])]), _vm._v(" "), _c('div', {
    staticClass: "filters-for-data flex items-center"
  }, [_c('div', {
    staticClass: "participant-minimums pl-subheading"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_vm._v("\n        Minimum invited to Written\n        "), _c('pl-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "centeredText": true,
      "type": "number"
    },
    model: {
      value: (_vm.filter_minimum_online_invites),
      callback: function($$v) {
        _vm.filter_minimum_online_invites = $$v
      },
      expression: "filter_minimum_online_invites"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-between"
  }, [_vm._v("\n        Minimum invited to Verbal\n        "), _c('pl-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "centeredText": true,
      "type": "number"
    },
    model: {
      value: (_vm.filter_minimum_live_invites),
      callback: function($$v) {
        _vm.filter_minimum_live_invites = $$v
      },
      expression: "filter_minimum_live_invites"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "participant-minimums pl-subheading"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_vm._v("\n        Minimum participated in Written\n        "), _c('pl-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "centeredText": true,
      "type": "number"
    },
    model: {
      value: (_vm.filter_minimum_online_submitted),
      callback: function($$v) {
        _vm.filter_minimum_online_submitted = $$v
      },
      expression: "filter_minimum_online_submitted"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-between"
  }, [_vm._v("\n        Minimum participated in Verbal\n        "), _c('pl-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "centeredText": true,
      "type": "number"
    },
    model: {
      value: (_vm.filter_minimum_live_participated),
      callback: function($$v) {
        _vm.filter_minimum_live_participated = $$v
      },
      expression: "filter_minimum_live_participated"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "date-pickers pl-subheading date-pickers ml4"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_vm._v("\n        Start Date\n        "), _c('pl-input', {
    attrs: {
      "centeredText": true,
      "type": "date"
    },
    model: {
      value: (_vm.start_date),
      callback: function($$v) {
        _vm.start_date = $$v
      },
      expression: "start_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-between"
  }, [_vm._v("\n        End Date\n        "), _c('pl-input', {
    attrs: {
      "centeredText": true,
      "type": "date"
    },
    model: {
      value: (_vm.end_date),
      callback: function($$v) {
        _vm.end_date = $$v
      },
      expression: "end_date"
    }
  })], 1)])]), _vm._v(" "), _c('table', {
    staticClass: "roundtable-discussion-data tc"
  }, [_vm._m(2), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.report_start_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.report_end_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.number_of_active_teachers))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.online_roundtable_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.online_roundtable_participation_rate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.live_discussion_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.live_discussion_participation_rate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.premade_count))])])]), _vm._v(" "), _c('section', {
    staticClass: "discussion-info-card-section flex mt5 mw8"
  }, [_c('div', {
    staticClass: "online-side w-50"
  }, [(_vm.filtered_online_data.length) ? _c('p', {
    staticClass: "pl-title tc blue"
  }, [_vm._v("\n        WRITTEN ROUNDTABLES\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filtered_online_data), function(rt) {
    return _c('div', {
      staticClass: "pa1 tl w-100 grow relative"
    }, [(rt.is_premade) ? _c('div', {
      staticClass: "absolute top-1 right-1 pl-title italics"
    }, [_vm._v("\n          PREMADE\n        ")]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "ma1 shadow-1 pa3 w-100 rt-info-card br4"
    }, [_c('tr', {
      staticClass: "pl-title blue"
    }, [_vm._v("\n            " + _vm._s(_vm.dateFormatted(rt.discussion_created_date)) + "\n          ")]), _vm._v(" "), _c('tr', {
      staticClass: "pl-subheading"
    }, [_vm._v("\n            " + _vm._s(rt.roundtable_title) + "\n          ")]), _vm._v(" "), _c('tr', [_vm._v("\n            " + _vm._s(rt.author_name) + "\n          ")]), _vm._v(" "), _c('tr', [_vm._v("\n            " + _vm._s(rt.author_email) + "\n          ")]), _vm._v(" "), _c('tr', [_vm._v("\n            " + _vm._s(rt.submitted) + "\n            submitted\n          ")]), _vm._v(" "), _c('tr', [_vm._v("\n            " + _vm._s(rt.count_invited) + "\n            invited\n          ")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "w-50 ml5"
  }, [(_vm.filtered_live_data.length) ? _c('p', {
    staticClass: "pl-title tc red"
  }, [_vm._v("\n        VERBAL DISCUSSIONS\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filtered_live_data), function(rt) {
    return _c('div', {
      staticClass: "pa1 tl w-100 grow"
    }, [_c('table', {
      staticClass: "ma1 shadow-1 pa3 w-100 rt-info-card br4"
    }, [_c('tr', {
      staticClass: "pl-title red"
    }, [_vm._v("\n            " + _vm._s(_vm.dateFormatted(rt.discussion_created_date)) + "\n          ")]), _vm._v(" "), _c('tr', {
      staticClass: "pl-subheading"
    }, [_vm._v("\n            " + _vm._s(rt.live_discussion_title) + "\n          ")]), _vm._v(" "), _c('tr', [_vm._v("\n            " + _vm._s(rt.author_name) + "\n          ")]), _vm._v(" "), _c('tr', [_vm._v("\n            " + _vm._s(rt.author_email) + "\n          ")]), _vm._v(" "), _c('tr', [_vm._v("\n            " + _vm._s(rt.number_participated) + "\n            participated\n          ")]), _vm._v(" "), _c('tr', [_vm._v("\n            " + _vm._s(rt.number_invited) + "\n            invited\n          ")])])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Total Teachers")]), _vm._v(" "), _c('th', [_vm._v("Enrolled Students")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Active Teachers")]), _vm._v(" "), _c('th', [_vm._v("Active Students")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Start Date")]), _vm._v(" "), _c('th', [_vm._v("End Date")]), _vm._v(" "), _c('th', [_vm._v("Active Teachers")]), _vm._v(" "), _c('th', [_vm._v("Written RoundTables")]), _vm._v(" "), _c('th', [_vm._v("Written Participation Rate")]), _vm._v(" "), _c('th', [_vm._v("Verbal RoundTables")]), _vm._v(" "), _c('th', [_vm._v("Verbal Participation Rate")]), _vm._v(" "), _c('th', [_vm._v("Universe RoundTables")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2e869a55!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/individualSchoolTabs/schoolEngagementSummary.vue
// module id = 1988
// module chunks = 61